class CollapsibleElements extends HTMLElement {
  constructor() {
    super();
    
    this.onCollapsibleClick = this.onCollapsibleClick.bind(this);
    this.onTransitionEnd = this.onTransitionEnd.bind(this);
  }

  connectedCallback() {
    this.collapsibles = this.querySelectorAll('[data-collapsible]');
    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  bindEvents() {
    this.collapsibles.forEach((collapsible) => {
      const trigger = collapsible.querySelector('[data-collapsible-trigger]');
      const body = collapsible.querySelector('[data-collapsible-body]');

      if (trigger) {
        trigger.addEventListener('click', this.onCollapsibleClick);
      }

      if (body) {
        body.addEventListener('transitionend', this.onTransitionEnd);
      }
    });
  }

  unbindEvents() {
    this.collapsibles.forEach((collapsible) => {
      const trigger = collapsible.querySelector('[data-collapsible-trigger]');
      const body = collapsible.querySelector('[data-collapsible-body]');

      if (trigger) {
        trigger.removeEventListener('click', this.onCollapsibleClick);
      }

      if (body) {
        body.removeEventListener('transitionend', this.onTransitionEnd);
      }
    });
  }

  onTransitionEnd(event) {
    const body = event.target;
    const collapsible = body.closest('[data-collapsible]');
    
    if (event.target !== body || !collapsible) return;

    if (collapsible.getAttribute('open') === 'true') {
      this.setBodyHeight(body, 'auto');
    }

    if (collapsible.getAttribute('open') === 'false') {
      collapsible.removeAttribute('open');
      this.setBodyHeight(body, '');
    }
  }

  onCollapsibleClick(event) {
    event.preventDefault();

    const trigger = event.currentTarget;
    const collapsible = trigger.closest('[data-collapsible]');
    
    if (!collapsible) return;

    // Toggle current collapsible
    if (collapsible.hasAttribute('open')) {
      this.close(collapsible);
    } else {
      this.open(collapsible);
    }
  }

  open(collapsible) {
    if (collapsible.hasAttribute('open')) return;

    const body = collapsible.querySelector('[data-collapsible-body]');
    const content = collapsible.querySelector('[data-collapsible-content]');

    if (!body || !content) return;

    collapsible.setAttribute('open', 'true');
    this.setBodyHeight(body, content.offsetHeight);
  }

  close(collapsible) {
    if (!collapsible.hasAttribute('open')) return;

    const body = collapsible.querySelector('[data-collapsible-body]');
    const content = collapsible.querySelector('[data-collapsible-content]');

    if (!body || !content) return;

    collapsible.setAttribute('open', 'false');
    this.setBodyHeight(body, content.offsetHeight);
    
    setTimeout(() => {
      requestAnimationFrame(() => {
        this.setBodyHeight(body, 0);
      });
    }, 10);
  }

  setBodyHeight(body, contentHeight) {
    if (!body) return;
    
    if (contentHeight === 'auto' || contentHeight === '') {
      body.style.height = contentHeight;
    } else {
      body.style.height = `${contentHeight}px`;
    }
  }
}

if (!customElements.get('collapsible-elements')) {
  customElements.define('collapsible-elements', CollapsibleElements);
}